module.exports = {
    // server_api_url    : 'http://mesh-gapi-loc.jieyou.cn', 
    // server_api_url    : 'https://mesh-gapi-dev.jieyou.shop', 
    // server_api_url    : 'https://mesh-gapi-test.jieyou.shop', 
    // server_api_url    : 'https://mesh-gapi-online.zkruner.com', 
    // server_api_url    : 'https://mesh-gapi-online.jieyou.shop', 
    server_api_url    : 'https://gapi-online.soofun.online', 
    server_api_url_loc: '/api'
};
